// src/com/trans_plan_launch/TransPlanLaunchAndDownload.js
import React, { useState } from 'react';
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import { AppMenuUrl } from '../../value/AppConst';
import TransPlanLaunch from './TransPlanLaunch';
import TransPlanDownload from '../trans_plan_download/TransPlanDownload';

export default function TransPlanLaunchAndDownload({
    menu, parentMenu
}) {
    const [mountedViews, setMountedViews] = useState(() => ({
        [menu.menuUrl]: true,
    }));

    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        if(sib) {
            setMountedViews((prev) => {
                if(prev[sib.menuUrl]) return prev;
                return {...prev, [sib.menuUrl]: true};
            });
            menuRequestRepo({menu:sib, parentMenu:parentMenu});
        }
    };

    const viewServiceTags = <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />;

    return(
        <TopViewControl>
            {
                mountedViews[AppMenuUrl.TransPlan] &&
                <TransPlanLaunch
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl === AppMenuUrl.TransPlan}
                />
            }
            {
                mountedViews[AppMenuUrl.TransPlanDownload] &&
                <TransPlanDownload
                    viewServiceTags={viewServiceTags}
                    show={menu.menuUrl === AppMenuUrl.TransPlanDownload}
                />
            }
        </TopViewControl>
    )
}